module.exports = __webpack_public_path__ + "files/ef3a7a26abaa8825a1777a8b16864a83.svg";